<template>
  <div class="w-full">
    <!-- Banner Taller Virtual Desktop -->
    <div class="w-full max-w-6xl mx-auto rounded-2xl overflow-hidden hidden md:flex flex-col md:flex-row items-stretch shadow-lg bg-white relative">
      <!-- Columna de texto -->
      <div class="bg-black text-white flex-1 p-8 flex flex-col justify-center relative z-10">
        <h2
          class="mb-4"
          style="
            font-family: 'Inter', sans-serif;
            font-weight: 700;
            font-size: 28px;
            line-height: 120%;
            letter-spacing: 0%;
            vertical-align: middle;
          "
        >
          {{ bannerData.TITULO }}
        </h2>
        <p
          class="mb-6"
          style="
            font-family: 'Inter', sans-serif;
            font-weight: 400;
            font-size: 14px;
            line-height: 130%;
            letter-spacing: 0%;
          "
        >
          {{ bannerData.SUBTITULO }}
        </p>
        <div class="flex gap-4">
          <a :href="bannerData.URL1" target="_blank" class="bg-[#E38400] text-white font-semibold py-2 px-6 transition-colors" style="border-radius:5px;">{{ bannerData['BOTON 1'] }}</a>
        </div>
      </div>
      <!-- Columna de imagen -->
      <div
        class="flex-1 bg-center bg-cover relative z-5 bg-black"
        :style="`background-image: url('${bannerData.IMAGEN}');`"
      >
        <!-- Puedes dejar este div vacío, o agregar un overlay si lo deseas -->
      </div>
    </div>

    <!-- Banner Taller Virtual Mobile -->
    <div class="block md:hidden">
      <div class="max-w-xl mx-auto rounded-2xl overflow-hidden shadow-lg bg-black">
        <img
          :src="bannerData.IMAGEN"
          alt="Foto del tallerista"
          class="w-full h-48 object-cover"
          style="display:block;"
        />
        <div class="bg-black text-white p-6 flex flex-col items-start">
          <h2
            class="mb-3"
            style="
              font-family: 'Inter', sans-serif;
              font-weight: 700;
              font-size: 22px;
              line-height: 120%;
              letter-spacing: 0%;
              vertical-align: middle;
            "
          >
            {{ bannerData.TITULO }}
          </h2>
          <p
            class="mb-5"
            style="
              font-family: 'Inter', sans-serif;
              font-weight: 400;
              font-size: 13px;
              line-height: 130%;
              letter-spacing: 0%;
            "
          >
            {{ bannerData.SUBTITULO }}
          </p>
          <div class="flex flex-col gap-3 w-full">
            <a :href="bannerData.URL1" target="_blank" class="bg-[#E38400] text-white text-center font-semibold py-2 w-full transition-colors" style="border-radius:5px;">{{ bannerData['BOTON 1'] }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const bannerData = ref({
  TITULO: 'Taller virtual para mejorar historias',
  SUBTITULO: 'Inscribite al próximo taller de agosto',
  'BOTON 1': 'Inscribirme',
  URL1: 'https://tienda.orsai.org/products/taller-virtual-para-mejorar-historias-de-hernan-casciari-septiembre',
  'BOTON 2': 'Más información',
  URL2: 'https://escuela.orsai.org/inscripciones/1',
  IMAGEN: 'https://hernancasciari.fra1.digitaloceanspaces.com/mascara_banner_thc_f25fc477b7.png'
});

// Función para parsear CSV correctamente, manejando comillas y comas dentro de valores
const parseCSVLine = (line) => {
  const result = [];
  let current = '';
  let inQuotes = false;
  
  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];
    
    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        // Comilla escapada ""
        current += '"';
        i++; // Saltar la siguiente comilla
      } else {
        // Toggle estado de comillas
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      // Fin de campo
      result.push(current);
      current = '';
    } else {
      current += char;
    }
  }
  
  // Agregar el último campo
  result.push(current);
  
  return result;
};

const fetchBannerData = async () => {
  try {
    const response = await fetch('https://docs.google.com/spreadsheets/d/e/2PACX-1vQWBlQ7HDJqR37f4n2_iPk-e887jGyZoXgfVXW3GTmX40Of1PD4tX8E2Lhazio6ToBneoBUz28L0iF_/pub?gid=514914568&single=true&output=csv');
    const csvText = await response.text();
    
    console.log('Raw CSV text:', csvText);
    
    // Parse CSV - manejar el caso donde todo viene en una línea
    const lines = csvText.split('\n').filter(line => line.trim() !== '');
    console.log('Lines filtradas:', lines);
    
    if (lines.length >= 2) {
      const headers = parseCSVLine(lines[0]);
      const values = parseCSVLine(lines[1]);
      
      console.log('Headers:', headers);
      console.log('Values:', values);
      
      // Crear JSON mapeando cada columna con su valor
      // Solo considerar las primeras 7 columnas (TITULO, SUBTITULO, BOTON 1, URL1, BOTON 2, URL2, IMAGEN)
      const jsonData = {};
      for (let i = 0; i < Math.min(7, headers.length); i++) {
        const header = headers[i]?.trim();
        const value = values[i]?.trim() || '';
        if (header) {
          jsonData[header] = value;
        }
      }
      
      console.log('JSON mapeado:', jsonData);
      
      // Solo actualizar si tenemos los campos necesarios
      if (jsonData.TITULO && jsonData.IMAGEN) {
        bannerData.value = jsonData;
      } else {
        console.error('Faltan campos requeridos en el CSV');
      }
    } else {
      console.error('No hay suficientes líneas en el CSV');
    }
  } catch (error) {
    console.error('Error fetching banner data:', error);
    // Keep default values if fetch fails
  }
};

onMounted(() => {
  fetchBannerData();
});
</script> 